import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { responsePercent } from '../surveyProcessView';
import process from '../WorkEnvironmentSurveyProcess.module.css';

type Props = { voters: number; expected: number; max: number };

/** How many have pointed out measures. Nobody can see who, or what each person chose. */
export const HighlightProgressCard = ({ voters, expected, max }: Props): ReactElement => {
  const { t } = useTranslation();
  const percent = responsePercent(voters, expected);
  return (
    <section aria-labelledby="highlight-progress-heading" className={process.card}>
      <div className={process.cardBody}>
        <div className={process.cardHeading}>
          <Heading level={2} data-size="sm" id="highlight-progress-heading">
            {t('workEnvironmentMeasures.progress.title')}
          </Heading>
          <Paragraph data-size="sm" className={process.subtle}>
            {t('workEnvironmentMeasures.progress.max', { count: max })}
          </Paragraph>
        </div>
        <div className={process.count}>
          <span className={`ds-heading ${process.countNumber}`} data-size="xl">
            {voters}
          </span>
          <Paragraph>{t('workEnvironmentMeasures.progress.count', { expected, percent })}</Paragraph>
        </div>
        <div
          className={process.progressBar}
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={percent}
          aria-label={t('workEnvironmentMeasures.progress.title')}
        >
          <span style={{ width: `${percent}%` }} />
        </div>
        <Paragraph data-size="sm" className={process.subtle}>
          {t('workEnvironmentMeasures.progress.anonymous')}
        </Paragraph>
      </div>
    </section>
  );
};
